<template>
    <div class="pill-switch input-group-lg">
        <span v-if="label" class="pill-switch-label mr-2 mt-1">
            {{ label }}
        </span>

        <div class="custom-control custom-switch">
            <input
                :id="inputId"
                ref="seekModeSwitch"
                type="checkbox"
                :checked="isChecked"
                class="custom-control-input"
                @change="onChangeHandler"
            />

            <label class="custom-control-label" :for="inputId"></label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PillSwitch',
    props: {
        inputId: {
            type: String,
            required: true
        },
        isChecked: {
            type: Boolean,
            required: true
        },
        label: {
            type: String,
            default: ''
        }
    },
    methods: {
        onChangeHandler() {
            const { checked } = this.$refs.seekModeSwitch

            this.$emit('changed', !!checked)
        }
    }
}
</script>

<style lang="scss" scoped>
.pill-switch {
    display: flex;
    align-items: center;

    .pill-switch-label {
        font-size: 14px;
    }

    .custom-switch {
        .custom-control-label {
            cursor: pointer;

            // the pill
            &:before {
                height: 1.25rem;
                width: 2.3rem;
                border-radius: 3rem;
                box-shadow: none;
            }
            // the moving bullet
            &:after {
                height: 0.8rem;
                width: 0.8rem;
                margin-top: 0.1rem;
                margin-left: 0.15rem;
            }
        }

        .custom-control-input {
            // tilde ("~") means "sibling going after"
            &:not(:checked) ~ .custom-control-label {
                &:before {
                    background-color: $dark;
                    border-color: $dark;
                }
            }
            &:checked ~ .custom-control-label {
                &:before {
                    background-color: $blue;
                    border-color: $blue;
                }
            }
        }
    }
}
</style>
